import { DTOError } from 'src/error/errors/DTOError';
import type { OperatorInfo } from './types';

export const operatorInfoDTO = (data: unknown): OperatorInfo => {
  if (data && typeof data === 'object' && 'id' in data && 'name' in data) {
    return {
      id: typeof data.id === 'number' ? data.id : 0,
      name: typeof data.name === 'string' ? data.name : '',
    };
  }

  throw new DTOError('operatorInfoDTO', data);
};
